import BaseView from './BaseView';

import throttle from 'lodash.throttle';
import { gsap } from "gsap";

let view = null;

class Visit extends BaseView {
    constructor(container) {
        super(container);
    }

    init() {

        this.breakpoint = window.matchMedia('(min-width:992px)');

        this.navColumn = this.container.querySelector('[data-nav-column]');
        this.quickNav = this.container.querySelector('[data-visit-quicknav]');
        this.quickNavItems = this.quickNav.querySelectorAll('li');

        this.resizeObserver = new ResizeObserver(entries => {
			this.checkLastItemPerLine();
		});
		this.resizeObserver.observe(this.quickNav);
        this.checkLastItemPerLine();

        this.quickNavLinks = this.container.querySelectorAll('[data-quicknav-link]');
		this.quickNavLinks.forEach(link => {
			link.addEventListener('click', evt => {
				evt.preventDefault();

                const target = link.getAttribute('href');
                this.scrollToSection(target, 0.8);
			});
		});


        this.navSections = this.container.querySelectorAll('[data-visit-section]');

        // Scroll Listener
		this.boundScrollListener = throttle(this.handleScroll.bind(this), 50);
		window.addEventListener('scroll', this.boundScrollListener);
		this.handleScroll();


        // Scroll to target Section when clicking Nav Menu (while alreay on visit)
        this.navLinks = document.querySelectorAll('[data-visit-nav-link]');
        this.boundHandleNavClick = this.handleNavClick.bind(this);
        this.navLinks.forEach(link => {
			link.addEventListener('click', this.boundHandleNavClick);
		});
    }

    checkLastItemPerLine() {
        let prevTop = null;
        this.quickNavItems.forEach(item => {
            item.classList.remove('is-last-of-line');

            const top = item.getBoundingClientRect().top;

            if(top!=prevTop) {
                const prevItem = item.previousElementSibling;
                if(prevItem) {
                    prevItem.classList.add('is-last-of-line');
                }
            }
            prevTop = item.getBoundingClientRect().top;

        });
    }

    handleScroll() {

        if(this.breakpoint.matches) { // Desktop

            this.navSections.forEach(section => {
                const targetID = section.getAttribute('id');
                const relatedLink = this.quickNav.querySelector('[href="#'+targetID+'"');

                const linkTop = relatedLink.getBoundingClientRect().top;
                const sectionTop = section.getBoundingClientRect().top;

                if(sectionTop<linkTop) {
                    this.setActiveLink(targetID);
                }
            });

        } else { // Mobile

            this.navSections.forEach(section => {
                const targetID = section.getAttribute('id');

                const linkTop = this.quickNav.getBoundingClientRect().bottom;
                const sectionTop = section.getBoundingClientRect().top;

                if(sectionTop<linkTop) {
                    this.setActiveLink(targetID);
                }
            });

        }

    }

    setActiveLink(targetID) {
        const activeLink = this.quickNav.querySelector('[href="#'+targetID+'"');
        if(activeLink) {
            this.quickNavLinks.forEach(link => {
                link.classList.remove('is-active');
            });
            activeLink.classList.add('is-active');
        }
    }

    scrollToSection(target, duration = 0) {
        const targetSection = this.container.querySelector(target);
        const relatedLink = this.quickNav.querySelector('[href="'+target+'"');

        if(targetSection) {
            let yOffset = 0;

            if(this.breakpoint.matches) { // Desktop
                const navTop = this.quickNav.getBoundingClientRect().top;
                const navColumnTop = parseInt(getComputedStyle(this.navColumn).top)+1;

                yOffset = relatedLink.getBoundingClientRect().top - 1;
                if(navTop>navColumnTop) {
                    yOffset = navColumnTop + (relatedLink.getBoundingClientRect().top - navTop) - 1;
                }

            } else { // Mobile

                if(!document.body.classList.contains('body--has-scrolled-down')) {
                    yOffset = 41 + 34;
                } else {
                    yOffset = 41;
                }
            }

            gsap.to(window, {
                duration: duration,
                ease: 'power2.inOut',
                scrollTo: {
                    y: targetSection,
                    offsetY: yOffset
                },
            });
        }
    }

    destroy() {
		super.destroy();

        this.resizeObserver.disconnect();
        window.removeEventListener('scroll', this.boundScrollListener);

		this.navLinks.forEach(link => {
			link.removeEventListener('click', this.boundHandleNavClick);
		});
	}

}

export default {
    namespace: 'template-visit',
    beforeEnter: ({ current, next, trigger, four }) => {
        view = new Visit(next.container);
        view.init();
    },
    afterEnter: ({ current, next, trigger, four }) => {
        view.afterEnterFunctions();
    },
    afterLeave: ({ current, next, trigger }) => {
        view.destroy();
        view = null;
    },
};